import {
  ObjectType,
  DataType,
  Transform,
  SectionConfig,
  FieldMapping,
  PicklistOption,
} from '../types/metadata'

export const mockSections: SectionConfig[] = [
  {
    id: 's1',
    sectionKey: 'borrower_info',
    sectionLabel: 'Borrower Information',
    objectType: ObjectType.Lead,
    order: 1,
    active: true,
  },
  {
    id: 's2',
    sectionKey: 'co_borrower_info',
    sectionLabel: 'Co-Borrower Information',
    objectType: ObjectType.Lead,
    order: 2,
    active: true,
  },
  {
    id: 's3',
    sectionKey: 'property_info',
    sectionLabel: 'Property Information',
    objectType: ObjectType.Opportunity,
    order: 3,
    active: true,
  },
  {
    id: 's4',
    sectionKey: 'loan_details',
    sectionLabel: 'Loan Details',
    objectType: ObjectType.Opportunity,
    order: 4,
    active: true,
  },
  {
    id: 's5',
    sectionKey: 'employment_info',
    sectionLabel: 'Employment Information',
    objectType: ObjectType.Account,
    order: 5,
    active: true,
  },
  {
    id: 's6',
    sectionKey: 'income_info',
    sectionLabel: 'Income Information',
    objectType: ObjectType.Account,
    order: 6,
    active: true,
  },
  {
    id: 's7',
    sectionKey: 'assets_info',
    sectionLabel: 'Assets Information',
    objectType: ObjectType.Account,
    order: 7,
    active: true,
  },
  {
    id: 's8',
    sectionKey: 'declarations',
    sectionLabel: 'Declarations',
    objectType: ObjectType.Lead,
    order: 8,
    active: true,
  },
  {
    id: 's9',
    sectionKey: 'demographics',
    sectionLabel: 'Demographics',
    objectType: ObjectType.Lead,
    order: 9,
    active: false,
  },
]

export const mockFieldMappings: FieldMapping[] = [
  // Borrower Info
  {
    id: 'f1',
    questionKey: 'borrower.firstName',
    section: 'borrower_info',
    promptText: 'First Name',
    dataType: DataType.Text,
    targetSObject: ObjectType.Lead,
    targetFieldApiName: 'FirstName',
    positionInSection: 1,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
  {
    id: 'f2',
    questionKey: 'borrower.lastName',
    section: 'borrower_info',
    promptText: 'Last Name',
    dataType: DataType.Text,
    targetSObject: ObjectType.Lead,
    targetFieldApiName: 'LastName',
    positionInSection: 2,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
  {
    id: 'f3',
    questionKey: 'borrower.email',
    section: 'borrower_info',
    promptText: 'Email Address',
    dataType: DataType.Email,
    targetSObject: ObjectType.Lead,
    targetFieldApiName: 'Email',
    positionInSection: 3,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
  {
    id: 'f4',
    questionKey: 'borrower.phone',
    section: 'borrower_info',
    promptText: 'Phone Number',
    dataType: DataType.Phone,
    targetSObject: ObjectType.Lead,
    targetFieldApiName: 'Phone',
    positionInSection: 4,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.PhoneNormalize,
  },
  {
    id: 'f5',
    questionKey: 'borrower.maritalStatus',
    section: 'borrower_info',
    promptText: 'Marital Status',
    dataType: DataType.Picklist,
    targetSObject: ObjectType.Lead,
    targetFieldApiName: 'Marital_Status__c',
    positionInSection: 5,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
  {
    id: 'f6',
    questionKey: 'borrower.hasCoBorrower',
    section: 'borrower_info',
    promptText: 'Is there a co-borrower?',
    dataType: DataType.YesNo,
    targetSObject: ObjectType.Lead,
    targetFieldApiName: 'Has_CoBorrower__c',
    positionInSection: 6,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },

  // Co-Borrower Info (Conditional)
  {
    id: 'f7',
    questionKey: 'coborrower.firstName',
    section: 'co_borrower_info',
    promptText: 'Co-Borrower First Name',
    dataType: DataType.Text,
    targetSObject: ObjectType.Lead,
    targetFieldApiName: 'CoBorrower_FirstName__c',
    positionInSection: 1,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    conditionKey: 'borrower.hasCoBorrower',
    conditionValue: 'yes',
    transform: Transform.None,
  },
  {
    id: 'f8',
    questionKey: 'coborrower.lastName',
    section: 'co_borrower_info',
    promptText: 'Co-Borrower Last Name',
    dataType: DataType.Text,
    targetSObject: ObjectType.Lead,
    targetFieldApiName: 'CoBorrower_LastName__c',
    positionInSection: 2,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    conditionKey: 'borrower.hasCoBorrower',
    conditionValue: 'yes',
    transform: Transform.None,
  },

  // Property Info
  {
    id: 'f9',
    questionKey: 'property.address',
    section: 'property_info',
    promptText: 'Property Address',
    dataType: DataType.Text,
    targetSObject: ObjectType.Opportunity,
    targetFieldApiName: 'Property_Address__c',
    positionInSection: 1,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
  {
    id: 'f10',
    questionKey: 'property.type',
    section: 'property_info',
    promptText: 'Property Type',
    dataType: DataType.Picklist,
    targetSObject: ObjectType.Opportunity,
    targetFieldApiName: 'Property_Type__c',
    positionInSection: 2,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
  {
    id: 'f11',
    questionKey: 'property.purchasePrice',
    section: 'property_info',
    promptText: 'Purchase Price / Estimated Value',
    dataType: DataType.Currency,
    targetSObject: ObjectType.Opportunity,
    targetFieldApiName: 'Property_Value__c',
    positionInSection: 3,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },

  // Loan Details
  {
    id: 'f12',
    questionKey: 'loan.purpose',
    section: 'loan_details',
    promptText: 'Loan Purpose',
    dataType: DataType.Picklist,
    targetSObject: ObjectType.Opportunity,
    targetFieldApiName: 'Loan_Purpose__c',
    positionInSection: 1,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
  {
    id: 'f13',
    questionKey: 'loan.amount',
    section: 'loan_details',
    promptText: 'Loan Amount',
    dataType: DataType.Currency,
    targetSObject: ObjectType.Opportunity,
    targetFieldApiName: 'Amount',
    positionInSection: 2,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
  {
    id: 'f14',
    questionKey: 'loan.occupancyType',
    section: 'loan_details',
    promptText: 'Occupancy Type',
    dataType: DataType.Picklist,
    targetSObject: ObjectType.Opportunity,
    targetFieldApiName: 'Occupancy_Type__c',
    positionInSection: 3,
    required: true,
    isRequiredForCompletion: true,
    preferably: false,
    active: true,
    transform: Transform.None,
  },
]

export const mockPicklistOptions: PicklistOption[] = [
  // Marital Status
  {
    id: 'p1',
    questionKey: 'borrower.maritalStatus',
    optionLabel: 'Married',
    optionValue: 'Married',
    order: 1,
    active: true,
  },
  {
    id: 'p2',
    questionKey: 'borrower.maritalStatus',
    optionLabel: 'Unmarried',
    optionValue: 'Unmarried',
    order: 2,
    active: true,
  },
  {
    id: 'p3',
    questionKey: 'borrower.maritalStatus',
    optionLabel: 'Separated',
    optionValue: 'Separated',
    order: 3,
    active: true,
  },

  // Property Type
  {
    id: 'p4',
    questionKey: 'property.type',
    optionLabel: 'Single Family Detached',
    optionValue: 'SingleFamily',
    order: 1,
    active: true,
  },
  {
    id: 'p5',
    questionKey: 'property.type',
    optionLabel: 'Condominium',
    optionValue: 'Condo',
    order: 2,
    active: true,
  },
  {
    id: 'p6',
    questionKey: 'property.type',
    optionLabel: 'Townhouse',
    optionValue: 'Townhouse',
    order: 3,
    active: true,
  },
  {
    id: 'p7',
    questionKey: 'property.type',
    optionLabel: 'Multi-Family (2-4 units)',
    optionValue: 'MultiFamily',
    order: 4,
    active: true,
  },

  // Loan Purpose
  {
    id: 'p8',
    questionKey: 'loan.purpose',
    optionLabel: 'Purchase',
    optionValue: 'Purchase',
    order: 1,
    active: true,
  },
  {
    id: 'p9',
    questionKey: 'loan.purpose',
    optionLabel: 'Refinance (Rate/Term)',
    optionValue: 'RefinanceRateTerm',
    order: 2,
    active: true,
  },
  {
    id: 'p10',
    questionKey: 'loan.purpose',
    optionLabel: 'Refinance (Cash-Out)',
    optionValue: 'RefinanceCashOut',
    order: 3,
    active: true,
  },

  // Occupancy Type
  {
    id: 'p11',
    questionKey: 'loan.occupancyType',
    optionLabel: 'Primary Residence',
    optionValue: 'Primary',
    order: 1,
    active: true,
  },
  {
    id: 'p12',
    questionKey: 'loan.occupancyType',
    optionLabel: 'Second Home',
    optionValue: 'SecondHome',
    order: 2,
    active: true,
  },
  {
    id: 'p13',
    questionKey: 'loan.occupancyType',
    optionLabel: 'Investment Property',
    optionValue: 'Investment',
    order: 3,
    active: true,
  },
]
